module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "sample-size"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      Randomly select\n      "), _c('el-input-number', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "min": 1,
      "size": "mini"
    },
    on: {
      "change": _vm.handleSampleSizeChange
    },
    model: {
      value: (_vm.sampleSize),
      callback: function($$v) {
        _vm.sampleSize = $$v
      },
      expression: "sampleSize"
    }
  }), _vm._v("\n      profiles that fit the above criteria\n    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "exclusion-period"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n      Exclude profiles sampled in the last\n      "), _c('el-select', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "placeholder": "Select",
      "size": "mini",
      "clearable": ""
    },
    on: {
      "change": _vm.handleExclusionChange
    },
    model: {
      value: (_vm.exclusionPeriod),
      callback: function($$v) {
        _vm.exclusionPeriod = $$v
      },
      expression: "exclusionPeriod"
    }
  }, _vm._l((_vm.exclusionPeriods), function(exclusionPeriod) {
    return _c('el-option', {
      key: exclusionPeriod.value,
      attrs: {
        "label": exclusionPeriod.label,
        "value": exclusionPeriod.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), (_vm.insufficientProfiles) ? _c('el-alert', {
    attrs: {
      "title": "There are insufficient profiles fitting your filter criteria to draw this sample size",
      "type": "error"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52ceb1ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/RandomSampleFilter.vue
// module id = 3282
// module chunks = 3